
import React, { useContext } from 'react';
import AppContext from '../context/app/appContext';

const FilterLocations = ({ ident }) => {

    const appContext = useContext(AppContext);

    const expandToggle = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            appContext.toggleActiveFilter(ident);
        }
    }

    const showMap = (event) => {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            appContext.setMapView(true);
        }
    }


    return (
        <li className="filter-locations">
            <a className={appContext.activeFilters.indexOf(ident) >= 0 ? 'trigger selected' : 'trigger'} onClick={(event) => expandToggle(event)} onKeyDown={(event) => expandToggle(event)} href="/explore">Locations</a>
            <div className="expandable">
                <div className="mapbox" onClick={(event) => showMap(event)} onKeyDown={(event) => showMap(event)}><figure></figure></div>
            </div>
        </li>
    );
}

export default FilterLocations;